import { call, put } from 'redux-saga/effects'
import firebase from '../config/firebase'

import QuantityPromotions from '../reducers/quantityPromotionReducer'

export function* getQuantityPromotions() {
  try {
    const promotionRef = firebase.firestore().collection('quantity_promotions')

    const snapshot = yield call([promotionRef, promotionRef.get])
    const promotions = {}

    snapshot.forEach(doc => {
      promotions[doc.id] = { ...doc.data(), key: doc.id }
    })

    yield put(QuantityPromotions.setQuantityPromotions(promotions))
    yield put(QuantityPromotions.setLoaded(true))
  } catch (error) {
    yield put(QuantityPromotions.setLoaded(false))
  }
}

export function* deleteQuantityPromotion({ promotion }) {
  try {
    const dbRef = firebase.database().ref()
    const promotionRef = firebase.firestore().collection('quantity_promotions').doc(promotion.key)

    const update = {}

    update[`/restaurants/${promotion.merchant_id}/branches/${promotion.branch_id}/quantity_promotions`] = null

    yield call([promotionRef, promotionRef.delete])
    yield call([dbRef, dbRef.update], update)
  } catch (error) {
    alert(error)
  }
}


// WEBPACK FOOTER //
// ./src/sagas/quantityPromotionSaga.js